import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DynamicDialogComponent } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-add-tasks-modal',
  templateUrl: './add-tasks-modal.component.html',
  styleUrls: ['./add-tasks-modal.component.scss']
})
export class AddTasksModalComponent implements OnInit {

  formGroup : FormGroup = this.fb.group({
    profissional: [''],
    prazo: [''],
    nomeTarefa: [''],
    observacao: ['']
  });

  profissionais: any [] = [];
  prazos: any [] = [];

  constructor(public config: DynamicDialogComponent,public fb: FormBuilder) {}
  
  salvar() {
    // todo
    this.config.close();
  }

  cancelar() {
    // todo
    this.config.close();
  }

  ngOnInit() {
      this.profissionais = [
          { name: 'Todos', id: null },
          { name: 'Carlos', id: 1 },
          { name: 'Joao', id: 2 },
          { name: 'Ricardo', id: 3 },
          { name: 'Rogerio', id: 4 }
      ];
      this.prazos = ['1 semana','3 dias','5 dias'];
  }
}
